import state from './state';
import Store from '../../base/index';
import mutations from './mutations';


export default class Templates extends Store {
    constructor(model, ng){

        state.model = model;

        super({state, ng, mutations});
    }
}



// WEBPACK FOOTER //
// ./src/app/store/templates/main/index.js